/** Keeps a user with onboarding still due on the document list, where the onboarding modal opens. */
import { Navigate, useLocation } from 'react-router-dom';
import { navigation } from '@/navigation';
import { isFullPageChatPath } from '@/features/ai-chat/full-page-chat-path';
import { useOnboardingPending } from '../hooks/use-onboarding-pending';

/** Left alone besides the full-page assistant (see below); the policies are read from the gate. */
const ALLOWED_PATHS: readonly string[] = [navigation.documents(), navigation.policies()];

/**
 * Sends any other route to the document list while onboarding is pending, so a deep link never
 * skips it. The home page redirects on its own; `/tappeer-ai` stays open by URL (e-mail links).
 */
export function OnboardingRedirect() {
  const { pathname } = useLocation();
  const onboardingPending = useOnboardingPending();

  if (!onboardingPending || isFullPageChatPath(pathname) || ALLOWED_PATHS.includes(pathname)) {
    return null;
  }
  return <Navigate to={navigation.documents()} replace />;
}
